import { push } from 'react-router-redux'
import { logout } from '../actions/auth'

function loginRequired(store) {
  alert("Your session has expired. Please login again.");
  store.dispatch(logout())
  store.dispatch(push('/login'))
  window.location.reload(true)
}

function hasInvaldStatus(status) {
  const invalidStatuses = Object.freeze([401, 403])
  return invalidStatuses.includes(status)
}

const authenticationMiddleware = store => next => action => {
  const { payload } = action
  const statusExists = payload && payload.hasOwnProperty('status')

  if (!action.type.endsWith('FAILURE')) {
    return next(action)
  }

  if (statusExists && hasInvaldStatus(payload.status)) {
    loginRequired(store)
    return
  }

  return next(action)
}

export default authenticationMiddleware



// WEBPACK FOOTER //
// ./src/middleware/authentication.js